export default function EventExcerpt({
  excerpt,
}) {
  return (
    <div dangerouslySetInnerHTML={{ __html: excerpt }} />
  );
}
